<template>
  <v-data-table
    :headers="headers"
    :items="malls"
    :expanded.sync="expanded"
    single-expand
    show-expand
    sort-by="name"
    disable-pagination
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-dialog v-model="showEditor" max-width="700px" persistent>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('Malls.List.add')}}</v-btn>
          </template>
          <MallEditor 
            v-if="showEditor"
            ref="MallEditor"
            :defaultMall="editedIndex >= 0 ? malls[editedIndex] : null" 
            @save="save"
            @cancel="close"
            @invalid-form="$store.dispatch('errorMessage', $t('Message.Error.invalidForm'))"
          />
        </v-dialog>
      </v-toolbar>
      
    </template>
    <template v-slot:item.logo="{ item }">
      <v-img class="my-2" height="75px" aspect-ratio="3/2" :src="getMallLogoPath(item.logo) || '/default_logo.png'"></v-img>
    </template>
    <template v-slot:item.data-table-expand="{ expand, isExpanded }">
      <v-btn small color="secondary" :outlined="isExpanded" rounded @click="expand(!isExpanded)">
        <v-icon small>mdi-file-document-edit</v-icon>
        Edito
      </v-btn>
    </template>
    <template v-slot:item.actions="{ item, props }">
      <v-btn fab small icon @click="editItem(item)" color="secondary">
        <v-icon small>edit</v-icon>
      </v-btn>
      <v-btn fab small icon @click="deleteItem(item)" color="secondary">
        <v-icon small>delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <TextEditor
          :content="item.editorial"
          @save="saveEditorial"
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import Malls from '@/services/malls'
import MallEditor from '@/components/Mall/MallEditor'
import TextEditor from '@/components/Utils/TextEditor'
import FilesPathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
export default {
  components: { MallEditor, TextEditor },
  mixins: [FilesPathHelpersMixin],
  data: () => ({
    malls: [],
    tab: null,
    showEditor: false,
    editedIndex: -1,
    expanded: []
  }),

  computed: {
    headers () {
      return [
        { sortable: false, value: 'logo', width: '150px' },
        { text: this.$t('Malls.Form.name'), align: 'left', value: 'name' },
        { value: 'data-table-expand' },
        { sortable: false, value: 'actions', width: '200px' },
      ]
    }
  },

  watch: {
    showEditor (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    async initialize () {
      this.malls = await Malls.getAll()
    },

    editItem (item) {
      this.editedIndex = this.malls.indexOf(item)
      this.showEditor = true
    },

    async deleteItem (mall) {
      const valid = confirm(this.$t('Malls.Message.delete'))
      if (valid) {
        await Malls.delete(mall.id)
        const index = this.malls.indexOf(mall)
        this.malls.splice(index, 1)
      }
    },

    close () {
      this.showEditor = false
      this.$refs.MallEditor.resetForm()
      setTimeout(() => {
        this.editedIndex = -1
      }, 300)
    },

    async save (mall) {
      if (this.editedIndex > -1) {
        try {
          const updatedMall = await Malls.update(mall)
          if (mall.file) await Malls.updateLogo(updatedMall.id, mall.file)
          this.initialize()
          this.close()
        } catch (error) {
          this.$store.dispatch('errorMessage', this.$t('Message.Error.update'))
        }
      } else {
        try {
          const createdMall = await Malls.create(mall)
          if (mall.file) await Malls.updateLogo(createdMall.id, mall.file)
          this.initialize()
          this.close()
        } catch (error) {
            this.$store.dispatch('errorMessage', this.$t('Message.Error.create'))
        }
      }
    },
    
    async saveEditorial (content) {
      try {
        await Malls.updateEdito(this.expanded[0].id, content)
        this.$store.dispatch('successMessage', this.$t('Message.Success.updatePublished'))
        this.initialize()
      } catch (error) {
        this.$store.dispatch('errorMessage', this.$t('Message.Error.update'))
      }
    }
  }
}
</script>